(() => {
  "use strict";

  // Cosmetic only: keeps the button price in sync as the customer toggles
  // purchase type. Two UIs can change that: our own [data-purchase-option]
  // radios, OR Seal Subscriptions' own widget (One-time / Subscribe & save),
  // which Seal auto-injects onto this page and is what customers usually
  // interact with first since it renders above our radios.
  //
  // Seal's widget uses a hybrid pattern: a styled div[role="radio"] wrapping
  // a real <input class="sls-option">. Seal's own click handling may update
  // that input's checked state programmatically without firing a native
  // "change" event, so we don't rely on "change" for Seal's side — we listen
  // on click/pointerup at the document level and re-read Seal's state right
  // after, which reflects whatever Seal ends up doing regardless of how it
  // does it internally.
  const landingPrice = document.querySelector("[data-landing-price]");
  const landingButton = document.querySelector("[data-landing-button]");
  const ownOptions = document.querySelectorAll("[data-purchase-option]");
  const oneTimeOption = document.querySelector("[data-purchase-option]:not([data-selling-plan])");
  const subscriptionOption = document.querySelector("[data-purchase-option][data-selling-plan]");

  function applyOption(option) {
    if (!option) return;
    if (landingPrice) landingPrice.textContent = option.dataset.price || "";
    if (landingButton) landingButton.dataset.sellingPlan = option.dataset.sellingPlan || "";
  }

  function applyFromSealState() {
    const checked = document.querySelector('.sls-option[type="radio"]:checked');
    if (!checked) return;
    applyOption(checked.dataset.type === "subscription" ? subscriptionOption : oneTimeOption);
  }

  ownOptions.forEach((option) => {
    option.addEventListener("change", () => {
      if (option.checked) applyOption(option);
    });
  });

  // Belt-and-braces for Seal's side: native change event (covers the case
  // where Seal's input DOES fire one)...
  document.addEventListener("change", (event) => {
    if (event.target.closest(".sls-option")) applyFromSealState();
  });

  // ...plus click/pointerup anywhere inside Seal's purchase-option area,
  // re-read shortly after so we pick up whatever Seal ends up setting even
  // if it does so asynchronously or without a native change event.
  document.addEventListener("click", (event) => {
    if (!event.target.closest('[data-one-time-option-radio], [data-selling-plan-group-option-radio], .seal-row, .sls-option')) return;
    applyFromSealState();
    setTimeout(applyFromSealState, 50);
    setTimeout(applyFromSealState, 250);
  });

  applyOption(document.querySelector("[data-purchase-option]:checked"));
  applyFromSealState();
})();